import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 100,
    height: '100%',
    padding: theme.spacing(1),
    textAlign: 'center',
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  title: {
    marginTop: theme.spacing(1),
    fontWeight: 500,
  },
  icon: {
    fontSize: '2.25rem',
    color: theme.palette.primary.main,
  },
}));

export default useStyles;
